import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'app/store/store';

import { DropDownItem, Dropdown, Icon } from 'app/components';

import { setFindPort } from 'app/utils/selectedTargetsSlice';

import { Port } from 'ais-facade-api/api';


import styles from './PortActionCell.module.scss';
import clsx from 'clsx';
interface Props {
  port: Port;
}

export const PortActionCell = ({ port }: Props) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [dropdown, setDropdown] = useState(false);

  const canBeShown = typeof port?.lat === 'number' && typeof port?.lon === 'number';

  const showPort = () => {
    dispatch(setFindPort(port));
    navigate('/mapview');
  };

  return (
    <>
      <button
        className={styles.icon_button}
        aria-expanded={dropdown ? 'true' : 'false'}
        onClick={() => setDropdown((prev) => !prev)}
      >
        <Icon name="more-icon" color="var(--default-primary)" width="13px" height="3px" />
      </button>

      <Dropdown
        dropdown={dropdown}
        onClickOutside={() => {
          setDropdown(false);
        }}
      >
        <DropDownItem>
          <button
            className={clsx(styles.button, { [styles.disabled]: !canBeShown })}
            aria-disabled={!canBeShown}
            disabled={!canBeShown}
            onClick={canBeShown ? showPort : undefined}
          >
            {t('ShowOnMap')}
          </button>
        </DropDownItem>
        <DropDownItem>
          <Link to={`/ports/${port.key}`} className={styles.button}>
            {t('PortInfo')}
          </Link>
        </DropDownItem>
      </Dropdown>
    </>
  );
};
